import React, { useEffect, useState } from "react";

const EditGiftCard = ({
  initialData,
  editableFields,
  handleSave,
  agencyList,
  countryList,
  brandList
}) => {
  const [formData, setFormData] = useState({});

  // Prefill data from API
  useEffect(() => {
    if (initialData) {
      const agencyId = agencyList?.find(a => a.agencyName === initialData.agency)?.id;
      const brandId = brandList?.find(b => b.name === initialData.brand)?.id;
      const countryId = countryList?.find(c => c.title === initialData.country)?.id;

      setFormData({
        ...initialData,
        agency: agencyId || "",
        brand: brandId || "",
        country: countryId || ""
      });
    }
  }, [initialData, agencyList, brandList, countryList]);

  const handleChange = (e, field) => {
    const { value } = e.target;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    handleSave(formData);
  };

  return (
    <div className="w-full flex justify-center">
      {/* Form container with smaller width */}
      <div className="w-full max-w-md ">
        <div className="grid grid-cols-2 gap-4 text-sm">

          {editableFields.map(field => (
            <div
              key={field}
              className={`flex flex-col ${field === "detail" ? "col-span-2" : ""}`}
            >
              <label className="mb-1 text-gray-700 font-medium capitalize">{field}</label>

              {/* DETAIL FULL WIDTH */}
              {field === "detail" ? (
                <textarea
                  value={formData[field] || ""}
                  onChange={(e) => handleChange(e, field)}
                  rows={3}
                  className="border px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              )

              /* STATUS CHECKBOX */
              : field === "status" ? (
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={!!formData[field]}
                    onChange={(e) =>
                      setFormData(prev => ({ ...prev, [field]: e.target.checked }))
                    }
                  />
                  <span>{formData[field] ? "Active" : "Inactive"}</span>
                </div>
              )

              /* SELECTS: agency / brand / country */
              : ["agency", "brand", "country"].includes(field) ? (
                <select
                  value={formData[field] || ""}
                  onChange={(e) => handleChange(e, field)}
                  className="border px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">Select {field}</option>
                  {field === "agency" && agencyList?.map(a => (
                    <option key={a.id} value={a.id}>{a.agencyName}</option>
                  ))}
                  {field === "brand" && brandList?.map(b => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                  {field === "country" && countryList?.map(c => (
                    <option key={c.id} value={c.id}>{c.title}</option>
                  ))}
                </select>
              )

              /* NUMBER FIELDS */
              : field === "value" || field === "stock" ? (
                <input
                  type="number"
                  value={formData[field] || ""}
                  onChange={(e) => handleChange(e, field)}
                  className="border px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              )

              /* DEFAULT TEXT */
              : (
                <input
                  type="text"
                  value={formData[field] || ""}
                  onChange={(e) => handleChange(e, field)}
                  className="border px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              )}
            </div>
          ))}

        </div>

        {/* SAVE BUTTON */}
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-[var(--mainCol)] text-white py-1.5 px-4 text-sm rounded hover:bg-[var(--mainColHover)] transition"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditGiftCard;